import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlurTextComponent } from './blur-text.component';

@NgModule({
    declarations: [
        BlurTextComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        BlurTextComponent
    ]
})
export class NcBlurTextModule { }